import React, { useState } from 'react';

function PrivacyPolicy() {
  const [lang, setLang] = useState('hr');

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '40px 20px 80px', fontFamily: 'sans-serif', color: '#222' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
        <a href="/" style={{ color: '#2d6a4f', textDecoration: 'none', fontWeight: 600 }}>← Ubrano</a>
        <div>
          <button onClick={() => setLang('hr')} style={{ marginRight: 8, fontWeight: lang === 'hr' ? 700 : 400, background: 'none', border: 'none', cursor: 'pointer', color: '#2d6a4f' }}>HR</button>
          <button onClick={() => setLang('en')} style={{ fontWeight: lang === 'en' ? 700 : 400, background: 'none', border: 'none', cursor: 'pointer', color: '#2d6a4f' }}>EN</button>
        </div>
      </div>

      {lang === 'hr' ? <HR /> : <EN />}
    </div>
  );
}

function HR() {
  return (
    <>
      <h1 style={{ color: '#2d6a4f' }}>Pravila privatnosti</h1>
      <p style={{ color: '#666' }}>Zadnje ažuriranje: srpanj 2026.</p>

      <h2>1. Voditelj obrade</h2>
      <p>
        Ubrano je usluga koja povezuje lokalne poljoprivrednike (OPG-ove) s kupcima.
        Za sva pitanja u vezi s privatnošću kontaktirajte nas putem e-maila:
        <strong> privacy@ubrano.com.hr</strong>
      </p>

      <h2>2. Koje podatke prikupljamo</h2>
      <p>Prikupljamo samo podatke nužne za funkcioniranje usluge:</p>
      <ul>
        <li><strong>Podaci o računu:</strong> e-mail adresa, zaporka (pohranjena kao hash), ime i prezime (neobavezno).</li>
        <li><strong>Podaci za prodavače (OPG):</strong> naziv OPG-a, MIBPG, telefonski broj, lokacija OPG-a (prikazuje se samo vama, ne kupcima).</li>
        <li><strong>Podaci o lokaciji:</strong> GPS lokacija (samo u trenutku pretraživanja ponude ili postavljanja zone upozorenja) i koordinate zona upozorenja koje ručno pohranite.</li>
        <li><strong>Podaci o aktivnosti:</strong> iskazani interesi za polja, štandove i dostave, ocjene OPG-ova i proizvoda.</li>
        <li><strong>Podaci za plaćanje:</strong> iznos transakcije i e-mail za slanje potvrde (neobavezno). Ne pohranjujemo podatke platnih kartica.</li>
      </ul>

      <h2>3. Svrha obrade</h2>
      <ul>
        <li>Prikaz relevantnih ponuda u vašoj blizini.</li>
        <li>Slanje obavijesti o ponudama kada prodavač to zatraži (uz vašu prethodnu suglasnost postavljanjem zone upozorenja).</li>
        <li>Generiranje platnog barkoda (HUB-3A) za plaćanje putem bankovnih aplikacija.</li>
        <li>Slanje informativne potvrde o plaćanju e-mailom (nije fiskalizirani račun).</li>
        <li>Prikaz ocjena OPG-ova i proizvoda svim korisnicima.</li>
      </ul>

      <h2>4. Pravna osnova</h2>
      <p>
        Obrada se temelji na izvršavanju ugovora (pružanje usluge koju ste zatražili) i
        legitimnom interesu (sigurnost i zaštita od zloupotrebe). Za obavijesti temeljene
        na lokaciji: vaša izričita suglasnost (postavljanje zona upozorenja).
      </p>

      <h2>5. Dijeljenje podataka s trećim stranama</h2>
      <p>Ne prodajemo vaše podatke. Koristimo sljedeće podizvođače:</p>
      <ul>
        <li><strong>Google LLC</strong> — prijava putem Google računa (Google OAuth), prikaz karata (Google Maps). Uvjeti: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#2d6a4f' }}>policies.google.com/privacy</a></li>
        <li><strong>DigitalOcean LLC</strong> — hosting servera u EU (Frankfurt). Uvjeti: <a href="https://www.digitalocean.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#2d6a4f' }}>digitalocean.com/legal/privacy-policy</a></li>
        <li><strong>Expo (expo.dev)</strong> — distribucija mobilne aplikacije. Uvjeti: <a href="https://expo.dev/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#2d6a4f' }}>expo.dev/privacy</a></li>
      </ul>
      <p>
        Kontaktni podaci prodavača (ime OPG-a, telefonski broj) vidljivi su kupcima koji pretražuju ponudu —
        to je osnovna svrha usluge.
      </p>

      <h2>6. Čuvanje podataka</h2>
      <ul>
        <li>Podaci o računu čuvaju se dok je račun aktivan.</li>
        <li>Događaji dostave automatski se brišu 120 dana nakon kreiranja.</li>
        <li>Zone upozorenja možete izbrisati u svakom trenutku iz postavki.</li>
        <li>Nakon brisanja računa, svi osobni podaci trajno se uklanjaju u roku od 30 dana.</li>
      </ul>

      <h2>7. Vaša prava (GDPR)</h2>
      <p>Imate pravo na:</p>
      <ul>
        <li><strong>Pristup</strong> — uvid u sve vaše podatke koje pohranjujemo.</li>
        <li><strong>Ispravak</strong> — ispravljanje netočnih podataka.</li>
        <li><strong>Brisanje</strong> — zahtjev za brisanjem računa i svih podataka.</li>
        <li><strong>Prenosivost</strong> — izvoz podataka u strojno čitljivom formatu.</li>
        <li><strong>Prigovor</strong> — prigovor na određene vrste obrade.</li>
      </ul>
      <p>
        Za ostvarivanje prava pišite na <strong>privacy@ubrano.com.hr</strong>.
        Odgovorit ćemo u roku od 30 dana. Imate i pravo podnijeti pritužbu
        Agenciji za zaštitu osobnih podataka (AZOP): <a href="https://azop.hr" target="_blank" rel="noopener noreferrer" style={{ color: '#2d6a4f' }}>azop.hr</a>.
      </p>

      <h2>8. Sigurnost</h2>
      <p>
        Svi podaci prenose se šifrirano (HTTPS/TLS). Zaporke su pohranjene kao sigurni hash
        (nikada u čitljivom obliku). Pristup bazi podataka ograničen je isključivo na
        aplikacijski server.
      </p>

      <h2>9. Kolačići</h2>
      <p>
        Aplikacija ne koristi kolačiće za praćenje. Koristimo localStorage preglednika
        isključivo za pohranu tokena za prijavu (nužno za funkcioniranje usluge).
      </p>

      <h2>10. Promjene pravila</h2>
      <p>
        O značajnim promjenama obavijestit ćemo vas e-mailom ili obavijesti unutar aplikacije
        najmanje 14 dana unaprijed.
      </p>

      <p style={{ marginTop: 48, color: '#888', fontSize: 14 }}>
        Ubrano · privacy@ubrano.com.hr · ubrano.com.hr
      </p>
    </>
  );
}

function EN() {
  return (
    <>
      <h1 style={{ color: '#2d6a4f' }}>Privacy Policy</h1>
      <p style={{ color: '#666' }}>Last updated: July 2026.</p>

      <h2>1. Data Controller</h2>
      <p>
        Ubrano is a service connecting local farmers (OPGs) with buyers.
        For all privacy-related questions, contact us at:
        <strong> privacy@ubrano.com.hr</strong>
      </p>

      <h2>2. What Data We Collect</h2>
      <p>We collect only what is necessary to operate the service:</p>
      <ul>
        <li><strong>Account data:</strong> email address, password (stored as a hash), first and last name (optional).</li>
        <li><strong>Seller data (OPG):</strong> farm name, MIBPG registration number, phone number, OPG location (shown only to you, not to buyers).</li>
        <li><strong>Location data:</strong> GPS location (only at the moment of searching for nearby listings, or when you set an alert zone), and the coordinates of alert zones you manually save.</li>
        <li><strong>Activity data:</strong> expressed interest in fields, stands, and delivery events; OPG and product ratings.</li>
        <li><strong>Payment data:</strong> transaction amount and optional receipt email. We do not store card details.</li>
      </ul>

      <h2>3. Purpose of Processing</h2>
      <ul>
        <li>Showing relevant listings near your location.</li>
        <li>Sending notifications about listings when a farmer requests it (requires your prior consent by setting an alert zone).</li>
        <li>Generating HUB-3A payment barcodes for bank app payments.</li>
        <li>Sending an informational payment confirmation by email (not a legally fiscalized receipt).</li>
        <li>Displaying OPG and product ratings to all users.</li>
      </ul>

      <h2>4. Legal Basis</h2>
      <p>
        Processing is based on the performance of a contract (providing the service you requested) and
        legitimate interest (security and abuse prevention). For location-based notifications:
        your explicit consent (by setting alert zones).
      </p>

      <h2>5. Sharing Data with Third Parties</h2>
      <p>We do not sell your data. We use the following sub-processors:</p>
      <ul>
        <li><strong>Google LLC</strong> — Google account sign-in (OAuth), map display (Google Maps). Privacy policy: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#2d6a4f' }}>policies.google.com/privacy</a></li>
        <li><strong>DigitalOcean LLC</strong> — EU server hosting (Frankfurt). Privacy policy: <a href="https://www.digitalocean.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#2d6a4f' }}>digitalocean.com/legal/privacy-policy</a></li>
        <li><strong>Expo (expo.dev)</strong> — mobile app distribution. Privacy policy: <a href="https://expo.dev/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#2d6a4f' }}>expo.dev/privacy</a></li>
      </ul>
      <p>
        Seller contact details (farm name, phone number) are visible to buyers searching for listings —
        this is the core purpose of the service.
      </p>

      <h2>6. Data Retention</h2>
      <ul>
        <li>Account data is kept while the account is active.</li>
        <li>Delivery events are automatically deleted 120 days after creation.</li>
        <li>Alert zones can be deleted at any time from your settings.</li>
        <li>After account deletion, all personal data is permanently removed within 30 days.</li>
      </ul>

      <h2>7. Your Rights (GDPR)</h2>
      <p>You have the right to:</p>
      <ul>
        <li><strong>Access</strong> — view all data we hold about you.</li>
        <li><strong>Rectification</strong> — correct inaccurate data.</li>
        <li><strong>Erasure</strong> — request deletion of your account and all associated data.</li>
        <li><strong>Portability</strong> — export your data in a machine-readable format.</li>
        <li><strong>Objection</strong> — object to certain types of processing.</li>
      </ul>
      <p>
        To exercise your rights, write to <strong>privacy@ubrano.com.hr</strong>.
        We will respond within 30 days. You also have the right to lodge a complaint with
        Croatia's data protection authority (AZOP): <a href="https://azop.hr" target="_blank" rel="noopener noreferrer" style={{ color: '#2d6a4f' }}>azop.hr</a>.
      </p>

      <h2>8. Security</h2>
      <p>
        All data is transmitted encrypted (HTTPS/TLS). Passwords are stored as secure hashes
        (never in readable form). Database access is restricted exclusively to the application server.
      </p>

      <h2>9. Cookies</h2>
      <p>
        The application does not use tracking cookies. We use browser localStorage
        solely to store your login token (necessary for the service to function).
      </p>

      <h2>10. Changes to This Policy</h2>
      <p>
        We will notify you of significant changes by email or in-app notification
        at least 14 days in advance.
      </p>

      <p style={{ marginTop: 48, color: '#888', fontSize: 14 }}>
        Ubrano · privacy@ubrano.com.hr · ubrano.com.hr
      </p>
    </>
  );
}

export default PrivacyPolicy;
